import React, { useEffect, useState } from 'react';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";
import Task from './Task';

const ProblemDescript = () => {
    const [problemInfo, setProblemInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.problemDescript,
            })
            .then((response) => {
                const problemDoc = response.data.allProblem_descripts.edges[0].node;
                setProblemInfo(problemDoc);
            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <div>
            <div className="problem-info pb-5 d-flex justify-content-between align-items-center">
                <img src={problemInfo?.img?.url} className="img-fluid" alt="" />
                <p className="px-5 body-text">{problemInfo?.img_side_text[0]?.text}</p>
            </div>

            <div className="task-box">
                <h5 className="robot-challenge-title">{problemInfo?.title[0]?.text}</h5>
                <p className="body-text">{problemInfo?.description[0]?.text.slice(0, 1437)} <span className="fw-bold py-2 d-block">{problemInfo?.description[0]?.text.slice(1437, 5000)}</span></p>
                {problemInfo?.task.map((task, index) => <Task key={index + 1} index={index + 1} task={task}></Task>)}
            </div>
            <div className="scroing pt-4">
                <h5 className="robot-challenge-title">{problemInfo?.scoring_title[0]?.text}</h5>
                <p className="body-text">{problemInfo?.scoring_des[0]?.text}</p>

                <ol>
                    {problemInfo?.scoring?.map((listInfo, index) => <li className="body-text" key={index + 1}> <span>{index + 1}.</span> {listInfo?.info[0]?.text}</li>)}
                </ol>

            </div>
        </div>
    );
};

export default ProblemDescript;